import { Browser, Device } from "@kakaopay-common/user-agent";
var PHASE = /* @__PURE__ */ ((PHASE2) => {
  PHASE2["SANDBOX"] = "SANDBOX";
  PHASE2["BETA"] = "BETA";
  PHASE2["PRODUCTION"] = "PRODUCTION";
  return PHASE2;
})(PHASE || {});
function getPhase() {
  if (window.location.hostname.includes("localhost") || window.location.hostname.includes("kp-fedev.kakao.com") || window.location.hostname.includes("local-") || window.location.hostname.includes("sandbox-")) {
    return "SANDBOX";
  }
  if (window.location.hostname.includes("beta-")) {
    return "BETA";
  }
  return "PRODUCTION";
}
function getWebScheme() {
  if (Browser.isKakaoTalkApp()) {
    if (Device.isIos() && getPhase() === "SANDBOX") {
      return "alphatalk://kakaopay/web";
    } else {
      return "kakaotalk://kakaopay/web";
    }
  } else {
    return "kakaopay://web";
  }
}
function getPayWebScheme() {
  if (Browser.isKakaoTalkApp()) {
    if (Device.isIos() && getPhase() === "SANDBOX") {
      return "alphatalk://kakaopay/payweb";
    } else {
      return "kakaotalk://kakaopay/payweb";
    }
  } else {
    return "kakaopay://payweb";
  }
}
export {
  PHASE,
  getPayWebScheme,
  getPhase,
  getWebScheme
};
